<template>
<div id="version">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <router-link class="breadcrumb-item" to="/avatamsaka/choose">
        {{$t('avatamsaka.choose.choose')}}
      </router-link>
      <li class="breadcrumb-item active" aria-current="page" v-if="filteredVersionList.length">
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.type[${versionId-1}].text`)
        })}}
      </li>
    </ol>
  </nav>
  <div class="sectionIntro" v-if="filteredVersionList.length">
    <div class="sectionBack">
    </div>
    <div class="introContent">
      <h2>
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.type[${versionId-1}].text`)
        })}}
      </h2>
      <p>
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.introType[${versionId-1}].text`)
        })}}
      </p>

      <router-link class="breadcrumb-item"
      :to="{path: '/avatamsaka/intro/' + versionId}" v-if="filteredVersionList.length">
        <b-button>
          {{$t('avatamsaka.introPage.introPageTitle')}}
        </b-button>
      </router-link>
    </div>
    <div class="introCover">
      <img class="w-100" :src="versionList[versionId-1].verImg">
    </div>
  </div>
  <div v-if="filteredSutraVersionList.length"  class="sutrasArea">
    <div v-for="item in filteredSutraVersionList"
    :info="item" :key="item.sutraId" class="sutraArea">
    <div v-if="sutraList.length" class="w-25 ">
      <img class="w-100" :src="sutraList[item.sutraId-1].sutraImg">
    </div>
      <div class="w-75">
      <div class="title">
        <p>
          {{$t('avatamsaka.sutras.sutra', {
            'noticeType': $t(`avatamsaka.sutras.type[${item.sutraId-1}].text`)
          })}}
        </p>
        <b-button v-if="versionId != 1" @click="getSutraContraPath(item.sutraId)">
          {{$t('avatamsaka.versions.boContrast')}}
        </b-button>
        <b-button @click="getSutraArticlePath(item.sutraId)">
          {{$t('avatamsaka.versions.articleRead')}}
        </b-button>
        <b-button @click="getSutraArticleVocabPath(item.sutraId)">
          {{$t('avatamsaka.versions.thisSutra')}}
        </b-button>
      </div>
      <p>
        {{$t('avatamsaka.sutras.sutra', {
          'noticeType': $t(`avatamsaka.sutras.introType[${item.sutraId-1}].text`)
        })}}
      </p>
    </div>
    </div>
    <div v-if="!filteredSutraVersionList.length">
    {{$t('avatamsaka.other.noThisVer')}}
    </div>
  </div>
  <div class="noThisVer" v-if="noThisVer">
    {{$t('avatamsaka.other.chooseOtherVer')}}
    <ul>
      <li @click="getVersionPath(1)">
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.type[0].text`)
        })}}
      </li>
      <li @click="getVersionPath(2)">
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.type[1].text`)
        })}}
      </li>
      <li @click="getVersionPath(3)">
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.type[2].text`)
        })}}
      </li>
      <li @click="getVersionPath(4)">
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.type[3].text`)
        })}}
      </li>
      <li @click="getVersionPath(5)">
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.type[4].text`)
        })}}
      </li>
    </ul>
  </div>
</div>
</template>

<script>

export default {
  name: 'version',
  data() {
    return {
      noThisVer: false,
    };
  },
  computed: {
    versionId() {
      return this.$route.params.vid;
    },
    versionList() {
      return this.$store.state.versionList;
    },
    sutraList() {
      return this.$store.state.sutraList;
    },
    versions() {
      return this.$store.getters.versions;
    },
    filteredVersionList() {
      let versionList = [...this.versionList];
      const nowVersionId = Number(this.versionId);

      if (nowVersionId !== '') {
        versionList = versionList.filter(item => item.id === nowVersionId);
      }

      return versionList;
    },
    filteredSutraVersionList() {
      let sutraList = [...this.filteredVersionList];

      if (sutraList.length !== 0) {
        sutraList = this.filteredVersionList[0].contents;
      }
      return sutraList;
    },
  },
  watch: {
    filteredSutraVersionList: function noVersion() {
      let versionEx = false;
      const versionList = [...this.filteredVersionList];

      if (versionList.length !== undefined) {
        if (versionList.length === 0) {
          versionEx = true;
        }
      }
      this.noThisVer = versionEx;
    },
  },
  methods: {
    getVersionPath(versionId) {
      this.$router.push({
        name: 'version',
        params: {
          vid: versionId,
        },
      });
    },
    getSutraArticlePath(sutraId) {
      this.$router.push({
        name: 'article',
        params: {
          sid: sutraId,
          vid: this.$route.params.vid,
        },
      });
    },
    getSutraArticleVocabPath(sutraId) {
      this.$router.push({
        name: 'categorySutra',
        params: {
          sid: sutraId,
          vid: this.$route.params.vid,
        },
      });
    },
    getSutraContraPath(sutraId) {
      this.$router.push({
        name: 'contra',
        params: {
          sid: sutraId,
          vid: this.$route.params.vid,
        },
      });
    },
  },
  mounted() {
    this.$store.dispatch('getVersionList');
    this.$store.dispatch('getSutraList');
  },
};
</script>

<style lang="scss" scoped>

#version {

  p{
    white-space: pre-line;
  }

  .breadcrumb {
    margin: 0;
    background: #d9e2c4;
  }

  .noThisVer {
    padding: 45px;
    font-size: 1.2em;
    ul {
      list-style: none;
      li {
        margin: 10px;
        padding: 5px;
        background: rgb(221, 242, 219);
      }
      li:hover {
        cursor: pointer;
        background: rgb(241, 235, 178);
      }
    }
  }

  .sectionIntro {
      display: flex;
      padding-bottom: 50px;
      position: relative;

    .sectionBack {
      margin-bottom: 40px;
      width: 100%;
      height: 60%;
      background: #d9e2c4;
      position: absolute;
      .breadcrumb {
        background: transparent;
        .breadcrumb-item{
          color: #4C4A4A;
        }
      }
    }

    .sectionBack::after {

        border-top: 20vh solid #d9e2c4;
        border-right: 50vw solid transparent;
        border-left: 50vw solid transparent;
        content: "";
        top: 100%;
        left: 0;
        position: absolute;

    }

    .introCover {
      position: sticky;
      flex: 1.4;
      padding: 0px;
      margin: 0px;
      img {
        max-width: 500px;
        width: 100%;
        float: right;
      }
    }
    .introContent {
      p {
        padding: 20px;
        padding-left: 0px;
      }
      position: sticky;
      flex: 2;
      margin: 1.8em;
      margin-top: 60px;
      margin-right: 60px;
      padding: 20px;
      text-align: left;
      align-self: center;
    }

    @media (max-width: 768px) {

    /deep/ nav {
      background: blue;
    }

        display: block;
        flex-direction: row;

        .introCover, .introContent {
          clear: both;
          display: block;
          width: 100%;
          flex: none;
          margin: 0px;
          padding: 40px;
        }

        .introContent {
          padding-top: 1.5em;
        }

        .introCover {
          position: relative;
          margin: 0;
          img {
            width: 100%;
          }
        }

    }
  }

  .sutrasArea {
    margin: 0 auto;
    max-width: 1500px;
    text-align: left;
    .sutraArea {
      margin: 1.8em;
      display: flex;
      div {
        padding: 20px;
        .title {
          font-size: 1.8em;
          padding: 0px;
          button {
            background: #d9e2c4;
            color: rgb(45, 42, 43);
            border: 1px solid #c2cbae;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {

    .sectionIntro {

      padding-bottom: 1em;

      .introCover {
        position: absolute;
        padding: 0px;
        bottom: 20%;
        right: 0;
        width: 60%;
      }

      .introContent {
        z-index: 1;
        margin: 0px;
        h2 {
          padding-top: 0.4em;
          background: rgba(255, 255, 255, 0.68);
          margin: 0;
          margin-top: 0px;
          padding-left: 0.4em;
          text-align: center;
        }
        p {

          background: rgba(255, 255, 255, 0.68);
          padding: 0px;
          padding: 0em 0.4em;
          text-align: center;
          margin-bottom: 1em;
          padding-bottom: 1em;
        }
        button {
          margin: 0 auto;
          display: block;
        }
      }

    }

    .sutrasArea {
      margin: 0px;

      div>.w-25 {
        padding: 0px;
      }

      div>.w-75 {

        padding: 0px;
        padding-left: 1em;

        .title {
          font-size: 1.5em;
          p {
            display: block;
            white-space: normal;
            margin: 0px;
          }
        }

        p {
          display: none;
        }
      }

      .sutraArea {
        margin: 1em;
      }

    }

  }

}

</style>



// WEBPACK FOOTER //
// src/components/Version.vue